module.exports = __webpack_public_path__ + "static/logo-f783157b48b91f54f7120b299f1b4454.png";